const ContactData = [
  {
    logo: `fa-solid fa-location-dot`,
    info: "Lagos, Nigeria",
    linkTo: "https://maps.app.goo.gl/qsvfgG81x7SQvvibA",
  },
  {
    logo: `fa-solid fa-phone`,
    info: "+2348153026203",
    linkTo: "tel:+2348153026203",
  },
  {
    logo: "fa-solid fa-envelope",
    info: "philipowolabi79@gmail.com",
    linkTo: "mailto:philipowolabi79@gmail.com",
  },
  {
    logo: "fa-solid fa-circle-check",
    info: "Available for Hire",
    linkTo: "https://calendly.com/d/cmm3-6vs-78h/interview",
  },
];

export default ContactData;
